



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class PageTitle extends Vue {
  @Prop({ required: true, type: String }) title; // 页面标题
  @Prop({ default: "", type: String }) customClass; // 自定义最外层类名
  @Prop({ default: "long-arrow-left", type: String }) icon; // 自定义左侧返回按钮icon名称
  @Prop({ default: true, type: Boolean }) border; // 是否需要显示底部边框线： true--显示 | false--隐藏
  @Prop({ default: false, type: Boolean }) isBack; // 是否需要显示返回按钮： true--显示 | false--隐藏
  @Prop({ default: "", type: String }) backName; // 自定义要返回的页面name
  @Prop({ type: Function }) backFn; // 自定义要返回的页面name

  get getBorder() {
    return this.border ? "is-border" : "";
  }
  goBack() {
    // 如果有传入自定义的页面name，则跳转到该页面，如果没有则默认回退到上一个页面
    if (this.backFn) {
      this.backFn();
    } else {
      if (!this.backName) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: this.backName });
      }
    }
  }
}
